module.exports = __webpack_public_path__ + "img/search-no.3c5ca070.png";